import { render, staticRenderFns } from "./logoutPage.vue?vue&type=template&id=ad408096&"
import script from "./logoutPage.vue?vue&type=script&lang=ts&"
export * from "./logoutPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports